import { useContext, useEffect } from 'react'

import { RootContext } from './DialogGuideRoot'

export interface InternalProps {
    closeOnSubmit?: boolean
}

export const useSetInternalProps = (props: InternalProps) => {
    const context = useContext(RootContext)

    if (!context) {
        throw new Error('RootContext not found')
    }

    useEffect(() => {
        context.setInternalProps(props)
    }, [])
}
